import * as React from 'react';
import { Activity } from "../../amorg-common";
import { useEffect } from 'react';
import { PublicAmorgUser } from '../../amorg-common';
import { ActivityComponentProps } from './common/ActivityComponentProps';
import { getActivity } from '../../api/activityClientApi';
import { getUsers } from '../../api/userClientApi';
import { UserToken } from '../../amorg-common';
import { getAuthorizedActiveUserOrRedirect } from '../../api/serverApiHelpers';
import AgendaMeetingActivityView from './common/AgendaMeetingActivityView';

type MeetingActivityPageViewProps = {
    activityId:string
}

type State = {
    loading:boolean,
    activeUser:UserToken,
    activity:Activity,
    users:PublicAmorgUser[],
}

export default function MeetingActivityPageView(props:MeetingActivityPageViewProps): JSX.Element 
{
    const [state, setState] = React.useState<State>({
        loading:true,
        activeUser:null,
        activity:null,
        users:null
    })

    useEffect(() => {
        updateState();
    }, [props.activityId]);

    async function updateState()
    {
        setState({...state, loading:true});
        setState({
            loading:false,
            activeUser: await getAuthorizedActiveUserOrRedirect(['EditSurveys']),
            activity: await getActivity(props.activityId),
            users: await getUsers()
        });
    }

    const componentProps: ActivityComponentProps = {
        activeUser:state.activeUser,
        activity: state.activity,
        users: state.users,
        onActivityUpdated:updateState
    };

    return (
        <>
            {state.activity && (state.activity.activityType === 'WorkgroupMeeting' || state.activity.activityType === 'AnnualWorkgroupStatus') && 
                <AgendaMeetingActivityView {...componentProps} />
            }
        </>
    );
}
